<template>
  <div>
    <Search />
    <div class="inside-box2" v-if="$store.state.show">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{
            path: '/list',
            query: { field: $store.state.dataList[0].a100, category: '全部' },
          }"
          >{{ $store.state.dataList[0].a100 }}</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{
            path: '/list',
            query: {
              field: $store.state.dataList[0].a100,
              category: $store.state.dataList[0].a102,
            },
          }"
          >{{ $store.state.dataList[0].a102 }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $route.query.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="company">
        <div class="company-left">
          <div class="logo">
            <img
              v-if="$store.state.dataList[0].a104 != '暂无数据'"
              :src="$store.state.dataList[0].a104"
            />

            <i
              v-else
              class="el-icon-picture-outline"
              style="font-size: 60px; color: #ccc"
            ></i>
          </div>
        </div>
        <div class="company-right">
          <div class="title">
            <p v-if="$store.state.dataList[0].name != '暂无数据'">
              {{ $store.state.dataList[0].name }}
            </p>
            <p v-else>{{ $store.state.dataList[0].shares }}</p>
          </div>
          <div class="rule">
            <span>{{ $store.state.dataList[0].shares }}</span>
            <span>成立时间：{{ $store.state.dataList[0].dtime }}</span>
            <span class="luydiqu" @click="goToAbout">{{ $store.state.dataList[0].a107 }}</span>
            <span
			class="luydiqu"
			@click="goToAbout('2')"
              v-if="
                $store.state.dataList[0].a107 != $store.state.dataList[0].a108
              "
			
              >{{ $store.state.dataList[0].a108 }}</span
            >
            <span>{{ $store.state.dataList[0].a109 }}</span>
            <span v-if="$store.state.dataList[0].a105 != '暂无数据'">
              <el-link
                type="primary"
                :underline="false"
                :href="$store.state.dataList[0].a105"
                target="_blank"
              >
                查看官网</el-link
              >
            </span>
          </div>
          <el-divider></el-divider>
          <div
            class="Introduction"
            v-if="$store.state.dataList[0].a103 != '暂无数据'"
          >
            <p>{{ $store.state.dataList[0].a103 }}</p>
          </div>
        </div>
      </div>

      <ul class="company-data">
        <li class="commercial-box">
          <div class="title">
            <h1>工商</h1>
          </div>
          <div class="con commercial">
            <table>
              <tr>
                <td>企业名称</td>
                <td>{{ $store.state.dataList[0].shares }}</td>
                <td>法定代表人</td>
                <td>{{ $store.state.dataList[0].a106 }}</td>
              </tr>
              <tr>
                <td>注册资本</td>
                <td>{{ $store.state.dataList[0].a115 }}</td>
                <td>统一社会信用代码</td>
                <td>{{ $store.state.dataList[0].a117 }}</td>
              </tr>
              <tr>
                <td>成立时间</td>
                <td>{{ $store.state.dataList[0].dtime }}</td>
                <td>核准日期</td>
                <td>{{ $store.state.dataList[0].a116 }}</td>
              </tr>
              <tr>
                <td>企业类型</td>
                <td>{{ $store.state.dataList[0].a120 }}</td>
                <td>所属行业</td>
                <td>{{ $store.state.dataList[0].a121 }}</td>
              </tr>
            </table>
          </div>
        </li>
        <!-- <Information v-bind:Informationdata="Informationdata" :getzx="getzx" /> -->
        <Information />
		<Competing />
        <Financing />
        <Complaints />
        <spindex />
        <Rating />
        <Project />
		<report />
        <mapdata/>
      </ul>
    </div>
  </div>
</template>

<script>
import Search from "@/views/Search.vue";
import Information from "@/components/details/information.vue";
import Project from "@/components/details/project.vue";
import Financing from "@/components/details/financing.vue";
import Complaints from "@/components/details/complaints.vue";
import Rating from "@/components/details/rating.vue";
import Competing from "@/components/details/competing.vue";
import report from "@/components/details/report.vue";
import spindex from "@/components/details/spindex.vue";
import mapdata from "@/components/details/mapdata.vue"
export default {
  name: "Inside",
  data() {
    return {
      // Informationdata: [],
      qyname:'',
    };
  },
  components: {
    Search,
    Information,
    Project,
    Financing,
    Complaints,
    Rating,
    Competing,
	report,
	spindex,
    mapdata,
  },
  methods: {
    // getzx() {
    //   axios
    //     .get("/searchjson.html?p=1&n=10&terms=" + this.$route.query.name)
    //     .then((res) => {
    //       console.log(111);
    //       console.log(res);
    //       this.Informationdata = res.data.list;
    //     });
    // },
	goToAbout(a) {
		// 使用编程式导航跳转到/about路径
		if (a =='2' ){
			console.log('luyou ')
			this.$router.push({ name: 'list', query: {field: this.$store.state.dataList[0].a100, category: this.$store.state.dataList[0].a102, area:this.$store.state.dataList[0].a107, cit:this.$store.state.dataList[0].a108}})
		}else{
			this.$router.push({ name: 'list', query: {field: this.$store.state.dataList[0].a100, category: this.$store.state.dataList[0].a102, area:this.$store.state.dataList[0].a107}})
		}
	}
  },
  // watch: {
  //   qyname: "getzx",
  // },
  created() {
    if (this.$route.query.name != undefined) {
      this.$store.dispatch("getAxios", { name: this.$route.query.name });
    } else {
      this.$store.dispatch("getAxios", { shares: this.$route.query.shares });
    }
  },
  
  mounted() {
	let metaInfo = {
		title: "查数字经济企业 上网经社企业库",
		keywords: "企业库，查企业，数字经济，跨境电商，产业数字化，数字零售，数字生活，在线教育，数字健康，金融科技，数字文娱",
		description: ""
	}
	this.$store.commit("CAHNGE_META_INFO", metaInfo),
    setTimeout(() => {
      if (this.$store.state.dataList.length == 0) {
        this.$message.error("暂无此数据");
        setTimeout(() => {
          location.href =
            "/Index/wjs_search_res.html?kw=" + this.$route.query.name;
        }, 2000);
      } else {
        setShareInfo({
          title: "网经社企业库——" + this.$store.state.dataList[0].name,
          summary: this.$store.state.dataList[0].a103,
          pic: this.$store.state.dataList[0].a104,
          url: document.URL,
          WXconfig: {
            swapTitleInWX: true,
            appId: "",
            timestamp: "",
            nonceStr: "",
            signature: "",
          },
        });
      }
    }, 2000);
  },
};
</script>

<style>
.inside-box {
  max-width: 1200px;
  margin: 100px auto 0;
}
.inside-box2 {
  max-width: 1200px;
  min-height: 876px;
  margin: 50px auto 0;
}

.search-bg {
  margin-top: 30px;
}
.luydiqu {
	color: #409EFF;
}
.company {
  display: flex;
  background: #fff;
  border: 1px solid #e4e8ea;
  padding: 20px;
  margin-top: 20px;
}
.company-left {
  display: flex;
  align-items: center;
  background: #f8f8f8;
}
.company-left .logo {
  text-align: center;
  border: 1px solid #e4e8ea;
}
.company-left img {
  width: 160px;
}
.company-right {
  flex: 1;
  padding-left: 15px;
}
.company-right .title {
  margin: 8px 0 12px;
}
.company-right .title p {
  font-size: 20px;
  color: #333;
}
.company-right .rule {
  display: flex;
}
.company-right .rule span:not(:first-child)::before {
  content: "|";
  margin: 0 8px;
  color: #5b6169;
}
.company .el-divider--horizontal {
  margin: 10px 0;
}
.company-data {
  margin-top: 40px;
}
.company-data li {
  background: #fff;
  border: 1px solid #e4e8ea;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.03);
  margin-bottom: 40px;
}
.company-data .title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e4eaee;
  box-sizing: border-box;
  padding: 0 20px 0 40px;
}
.company-data .title h1 {
  font-size: 16px;
  color: #333;
  font-weight: 700;
  position: relative;
}
.company-data .title h1::before {
  content: "";
  width: 10px;
  height: 10px;
  background: cyan;
  position: absolute;
  top: calc(50% - 5px);
  left: -20px;
}
.company-data .con {
  padding: 20px;
}
.commercial table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #e4eaee;
}
.commercial tr {
  border-bottom: 1px solid #e4eaee;
}
.commercial td {
  width: 20%;
  font-size: 14px;
  color: #5b6169;
  border-right: 1px solid #e4eaee;
  line-height: 22px;
  display: table-cell;
  vertical-align: middle;
  padding: 10px 20px;
}
.commercial td:first-child,
.commercial td:nth-child(3) {
  background: #fafafb;
  font-weight: 700;
}

@media (max-width: 868px) {
  #app .el-breadcrumb {
    line-height: 1.5;
    padding: 0 10px;
  }

  .inside-box,
  .company {
    margin-top: 10px;
  }
  .company {
    padding: 10px;
  }
  .company-left {
    width: 100px;
  }
  .company-left .logo {
    flex: 0 0 30%;
  }
  .company-left img {
    width: 100px;
  }
  .company-right {
    position: relative;
  }
  .company-right .rule {
    flex-wrap: wrap;
    margin-top: 10px;
  }
  .company-right .rule span:first-child,
  .company-right .rule span:nth-child(2) {
    flex: 0 0 100%;
  }
  .company-right .rule span:last-child {
    width: 56px;
    position: absolute;
    top: 0;
    right: 0;
  }
  #app .company-right .rule span:last-child .el-link {
    display: block;
  }
  .company-right .rule span:nth-child(2)::before,
  .company-right .rule span:nth-child(3)::before,
  .company-right .rule span:last-child::before {
    display: none;
  }
  .company-data {
    margin-top: 20px;
  }
  .company-data li {
    margin-bottom: 20px;
  }
  .company-data .con {
    padding: 10px;
  }

  .commercial tr {
    display: flex;
    flex-wrap: wrap;
  }
  .commercial tr:last-child {
    border-bottom: none;
  }
  .commercial td {
    width: 60%;
    border-right: none;
    box-sizing: border-box;
  }
  .commercial td:first-child,
  .commercial td:nth-child(2) {
    border-bottom: 1px solid #e4eaee;
  }
  .commercial td:first-child,
  .commercial td:nth-child(3) {
    width: 40%;
  }
}
</style>